import React, { forwardRef, useEffect } from "react";
import Box from "@mui/material/Box";
import useInvoiceManagement from "./fast-entry-page/hooks/useInvoiceManagement";
import FastEntryInvoiceContainer from "./fast-entry-page/FastEntryInvoiceContainer";
import { useDispatch } from "react-redux";
import { clearInvoices } from "features/fastEntrySlice";

const FastEntryInvoicesPanel = React.memo(React.forwardRef((props, ref) => {
  // Call useInvoiceManagement for any side effects, but do not destructure unused variables
  useInvoiceManagement({});
  
  // Get dispatch to clear invoices
  const dispatch = useDispatch();
  
  // Clear fast entry invoices when rendered in InvoicePage
  useEffect(() => {
    // Clear invoices when component mounts
    dispatch(clearInvoices());
    // No cleanup needed
  }, [dispatch]);

  return (
    <Box sx={{ marginBottom: "1rem" }}>
      <FastEntryInvoiceContainer
        ref={ref}
        height={props.height}
        minHeight={props.minHeight}
        sx={{
          height: "auto",
          minHeight: "unset",
          maxHeight: "unset",
        }}
      />
    </Box>
  );
}));

export default FastEntryInvoicesPanel; 